import { useAuthContext } from '@/contexts/auth-context';

export type SourceFlag =
  | 'hire-source-async-job-posting'
  | 'source-freemium'
  | 'source-indeed-contract'
  | 'source-location-timezone-ranges'
  | 'source-reach-campaign-breakdown'
  | 'sourcing-dashboard-user-access'
  | 'unified-navigation-exclusion';

export function isFlagOn(
  user:
    | { feature_flags?: Record<string, boolean | undefined> }
    | null
    | undefined,
  key: SourceFlag,
): boolean {
  return user?.feature_flags?.[key] === true;
}

export function useFlag(key: SourceFlag): boolean {
  const { whoami } = useAuthContext();
  return isFlagOn(whoami, key);
}
